import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RepositoryService {

  constructor(
    private http: HttpClient
  ) { }

  public repositoryId = "";
  public action = "";
  private options = { headers: new HttpHeaders().set('isUpload', 'true') };

  GetAllRepositoryDetails(){
    return this.http.get(environment.apiURL +`repository/GetAllRepositoryDetails?IsActive=true`);
  }
  GetAllRepositoryDetailsByCreatedDate(date){
    return this.http.get(environment.apiURL + `repository/GetAllRepositoryDetails?IsActive=true&CreatedOn=`+date);
  }
  GetAllRepositoryDetailsByDateWise(fromdate,todate){
    return this.http.get(environment.apiURL + `repository/GetAllRepositoryDetails?IsActive=true&FromDate=`+fromdate+`&ToDate=`+todate);
  }
  GetRepositoryDetailsById(repositoryId){
    return this.http.get(environment.apiURL + `repository/GetAllRepositoryDetails?_id=`+repositoryId);
  }
  GetClient(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetIndication(){
    return this.http.get(environment.apiURL+`master/GetIndication`);
  }
  GetTherapyArea(){
    return this.http.get(environment.apiURL + 'master/GetTheraphyArea');
  }
  AddRepository(data){
    return this.http.post(environment.apiURL + `repository/AddRepository`, data);
  }

  UploadRepoAttachment(formData){    
    return this.http.post(environment.apiURL + `repository/UploadRepositoryAttachment`, formData, this.options);
  }
  GetUserRepo(data){
    return this.http.post(environment.apiURL + `repository/GetUserRepository`, data);
  }
  UpdateRepository(data){
    return this.http.post(environment.apiURL + `repository/UpdateRepository`, data);
  }
  DeleteRepository(data){
    return this.http.post(environment.apiURL + `repository/DeleteRepository`, data);
  }

  DeleteRepoAttachFile(data) {
    return this.http.post(environment.apiURL + `repository/DeleteRepoAttachment`, data);
  }

  DeleteRepoAttach(data) {
    return this.http.post(environment.apiURL + `repository/DeleteRepositoryRepo`, data);
  }
  GetSharedRepositoryDetailsById(respoId){
    return this.http.get(environment.apiURL + `repository/GetSharedUserRepository?_id=`+respoId);
  }
}
